<template>
  <div class="login-container">
    <div class="loginHeader" v-if="isChrome">
      <img src="../assets/login/logo-lk.png" alt="">
      <div
        class="login-header-word login-header-word-login"
        :class="{'cuurent-login-header-word': currentForm===1}"
        @click="jumpTo(1)"
        >登录</div>
      <div
        class="login-header-word login-header-word-forget"
        :class="{'cuurent-login-header-word': currentForm===2 || currentForm===3}"
        @click="jumpToForget"
        >忘记密码</div>
    </div>
    <div class="center" v-if="isChrome">
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="ball"></div>
      <div class="centerHolder clear">
        <img src="../assets/login/mainLogin.png" alt="">
        <lk-card title="邻客智慧药房管理系统" class="formContainer" v-if="currentForm===1">
          <lk-form :model="loginData" label-position='left' key="login-from-1">
            <lk-form-item prop="userName" class="login-input">
              <DropdownInput
                ref='loginName'
                placeholder='系统用户名'
                :maxlength='100'
                @on-enter="onUserNameEnter"
                @on-search="handleSearchName"
                @on-focus="handleFocusName"
                :dropdownList="nameOptions"
                v-model.trim="loginData.userName">
                <span slot="prepend" class="iconfont gray-icon">&#xe60c;</span>
              </DropdownInput>
            </lk-form-item>
            <lk-form-item prop="password">
              <lk-input
              @on-enter="onEnter"
              ref="loginPassword"
              :maxlength='100' placeholder='密码' type='text' class="input-password" v-model="loginData.password">
                <span slot="prepend" class="iconfont gray-icon">&#xe627;</span>
                <lk-button slot="append" @click="jumpToForget">忘记密码？</lk-button>
              </lk-input>
            </lk-form-item>
            <!-- 图形验证码 -->
            <lk-form-item v-if="showAuthCode" ref="authCodeContainer">
              <lk-input
              @on-enter="onEnter"
              :maxlength='10' placeholder='输入图形验证码' type='text' v-model="authCode">
                <span slot="prepend" class="iconfont gray-icon">&#xe628;</span>
                <span slot="append" class="codeContain">
                  <img class="authCode" ref="authCodeImg" :src="authCodeData" alt="">
                  <lk-button @click="refreshAuthCode">刷新</lk-button>
                </span>
              </lk-input>
            </lk-form-item>
            <lk-form-item >
              <lk-button type ='primary' @click="handlelogin" long>登 录</lk-button>
            </lk-form-item>
          </lk-form>
        </lk-card>
        <!-- 找回密码 -->
        <lk-card title="找回密码" class="formContainer" v-if="currentForm===2" >
          <lk-form :model="findPasswordData" label-position='left' key="login-from-2">
            <lk-form-item prop="phone" ref="findPhone">
              <lk-input  :maxlength='100' placeholder='输入注册的手机号码' v-model.trim="findPasswordData.phone">
                <span slot="prepend" class="iconfont gray-icon">&#xe629;</span>
              </lk-input>
            </lk-form-item>
            <!-- 图形验证码 -->
            <lk-form-item ref="findAuthCodeContainer">
              <lk-input
              @on-enter="onEnter"
              :maxlength='10' placeholder='输入图形验证码' type='text' v-model="authCode">
                <span slot="prepend" class="iconfont gray-icon">&#xe628;</span>
                <span slot="append" class="codeContain">
                  <img class="authCode" ref="authCodeImg" :src="authCodeData" alt="">
                  <lk-button @click="refreshAuthCode">刷新</lk-button>
                </span>
              </lk-input>
            </lk-form-item>
            <lk-form-item prop="code" ref="findCode">
              <lk-input :maxlength='10' placeholder='输入手机验证码' v-model.trim="findPasswordData.code">
                <span slot="prepend" class="iconfont gray-icon">&#xe628;</span>
                <lk-button slot="append" @click="getCode" v-if="!showTimeout">获取手机验证码</lk-button>
                <span slot="append" v-if="showTimeout">{{`${waitTime}秒后重新发送`}}</span>
              </lk-input>
            </lk-form-item>
            <lk-form-item >
              <lk-button type ='primary' @click="validateSMS" long>找回密码</lk-button>
            </lk-form-item>
          </lk-form>
        </lk-card>
        <lk-card title="找回密码" class="formContainer" v-if="currentForm===3">
          <lk-form :model="newPasswordData" label-position='left' ref="newPassordForm" :rules="changePasswordRule" key="login-from-3">
            <lk-form-item prop="password"  ref="newPasswordDataPassword" >
              <lk-input  type='text'  class="input-password" :maxlength='100' placeholder='新密码'  autocomplete="new-password" @on-focus="onNewPasswordFocus" v-model.trim="newPasswordData.password">
                <span slot="prepend" class="iconfont gray-icon">&#xe627;</span>
              </lk-input>
            </lk-form-item>
            <div class="security-wrap" v-if="showSecurity">
              <span class="gray-word">安全性：</span>
              <div class="security-item" v-for="(item, index) in 3" :class="{[`${activeSecurityClass}`]: item<=securityLevel}" :key="index"></div>
              <span class="gray-word">{{securityLevelName}}</span>
            </div>
            <lk-form-item prop="passwordAgain" ref="newPasswordDataPasswordAgain">
              <lk-input  type='text' class="input-password" v-model="newPasswordData.passwordAgain"  autocomplete="new-password" :maxlength='100' placeholder='确认新密码'>
                <span slot="prepend" class="iconfont gray-icon">&#xe627;</span>
              </lk-input>
            </lk-form-item>
            <lk-form-item >
              <lk-button type ='primary' @click="changePassword" long>确 定</lk-button>
            </lk-form-item>
          </lk-form>
        </lk-card>
      </div>
    </div>
    <div class="loginfooter" v-if="isChrome">
      <img src="../assets/login/logo-dtp.png" alt="">
      <div class="intro">
        <div >零氪科技提供技术支持</div>
        <div >LinkDoc成立于2014年，致力于打造优质的医疗数据解决方案及肿瘤大数据平台，为中国的肿瘤专科医院及综合三甲医院，提供精准的临床结构化数据，协助医院解决科研及临床问题。帮助中国医疗机构及临床专家，更好的驾驭科技发展，享受数据福利。</div>
      </div>
      <img src="../assets/login/code.png" alt="">

    </div>
    <div class="no-chrome-container" v-if="!isChrome">
      <div class="no-chrome-wrap">
        <div class="chrome-grey-text">
          抱歉！您的浏览器无法打开此系统。
        </div>
        <img src="../assets/building.png" alt=""/>
        <div class="chrome-grey-text">
          请使用以下浏览器打开
        </div>
        <div class="chrome-black-text">
          Chrome浏览器或者切换360浏览器、QQ浏览器、搜狗浏览器为极速模式
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import user from '../services/user';
import DropdownInput from '../components/dropdownInput';
import utils from '../libs/utils';
import authority from '../mixins/authority';


export default {
  name: 'login',
  mixins: [authority],
  components: { DropdownInput },
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value !== this.newPasswordData.password) {
        callback(new Error('输入的密码不一致，请重新输入'));
      } else {
        callback();
      }
    };
    const validateNewPass = (rule, value, callback) => {
      const wordLength = value.length;
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (wordLength < 6) {
        callback(new Error('输入的密码安全性过低，请重新输入'));
      } else if (wordLength >= 20) {
        callback(new Error('输入的密码安全性过低，请重新输入'));
      } else if (!/^[A-Za-z0-9]+$/.test(value)) {
        callback(new Error('密码必须必须是数字和字母的组合'));
      } else if (/^[A-Z]+$/.test(value) || /^[a-z]+$/.test(value) || /^[0-9]+$/.test(value)) {
        callback(new Error('输入的密码安全性过低，请重新输入'));
      } else {
        callback();
      }
    };
    return {
      isChrome: true,
      showAuthCode: false,
      authCodeData: '',
      authCode: '',
      nameOptions: [],
      loginData: {
        userName: '',
        password: '',
      },
      findPasswordData: {
        phone: '',
        code: '',
      },
      newPasswordData: {
        password: '',
        passwordAgain: '',
        token: '',
        phone: '',
      },
      currentForm: 1,
      showTimeout: false,
      waitTime: 60,
      changePasswordRule: {
        passwordAgain: [
          { validator: validatePass, trigger: 'newEvent' },
        ],
        password: [
          { validator: validateNewPass, trigger: 'newEvent' },
        ],
      },
      showSecurity: false,
    };
  },
  computed: {
    securityLevel() {
      const password = this.newPasswordData.password;
      if (/^[A-Z]+$/.test(password) || /^[a-z]+$/.test(password) || /^[0-9]+$/.test(password)) {
        return 1;
      }
      if (/^[A-Z0-9]+$/.test(password) || /^[a-z0-9]+$/.test(password) || /^[a-zA-z]+$/.test(password)) {
        return 2;
      }
      if (/^[A-Za-z0-9]+$/.test(password)) {
        return 3;
      }
      return 0;
    },
    securityLevelName() {
      if (this.securityLevel === 1) {
        return '低';
      }
      if (this.securityLevel === 2) {
        return '中';
      }
      if (this.securityLevel === 3) {
        return '高';
      }

      return '';
    },
    activeSecurityClass() {
      if (this.securityLevel === 1) {
        return 'sercurity-low';
      }
      if (this.securityLevel === 2) {
        return 'sercurity-medium';
      }
      if (this.securityLevel === 3) {
        return 'sercurity-high';
      }
      return '';
    },
  },
  methods: {
    onEnter() {
      if (this.loginData.userName && this.loginData.password) {
        this.handlelogin();
      } else {
        this.$refs.loginName.focus();
      }
    },
    onUserNameEnter() {
      if (this.loginData.userName && this.loginData.password) {
        this.handlelogin();
      } else {
        this.$refs.loginPassword.focus();
        this.$refs.loginName.blur();
      }
    },
    testBrowser() {
      const userAgent = navigator.userAgent;
      const isChrome = !userAgent.includes('Edge') && (userAgent.indexOf('Chrome') > -1 || userAgent.indexOf('Safari') > -1);
      this.isChrome = isChrome; // && !this.isMobile();
    },
    isMobile() {
      const userAgent = navigator.userAgent;
      const isAndroid = /android/i.test(userAgent);
      const isIos = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
      return isAndroid || isIos;
    },
    handleFocusName(val) {
      if (val) {
        this.handleSearchName(val);
      } else {
        const newNumbers = this.getNames();
        const nameOptions = [];
        newNumbers.forEach((word) => {
          nameOptions.push({
            name: word,
            value: word,
          });
        });
        this.nameOptions = nameOptions;
      }
    },
    handleSearchName(value) {
      const newNumbers = this.getNames();
      const nameOptions = [];
      if (!value) return [];
      newNumbers.forEach((word) => {
        if (word.indexOf(value) != -1) {
          nameOptions.push({
            name: word,
            value: word,
          });
        }
      });
      this.nameOptions = nameOptions;
    },
    saveName(name) {
      const names = this.getNames();
      if (names.length >= 20) {
        names.shift();
      }
      if (names.indexOf(name) != -1) {
        return;
      }
      names.push(name);
      localStorage.setItem('loginedNames', JSON.stringify(names));
    },
    getNames() {
      const namesStr = localStorage.getItem('loginedNames');
      if (namesStr) {
        return JSON.parse(namesStr);
      // eslint-disable-next-line no-else-return
      } else {
        return [];
      }
    },
    jumpToForget() {
      this.jumpTo(2);
      this.loginData = {
        userName: '',
        password: '',
      };
      this.refreshAuthCode();
      this.showAuthCode = false;
      this.authCode = '';
    },
    jumpTo(val) {
      this.currentForm = val;
    },
    changePassword() {
      const {
        password,
        //  passwordAgain,
        token,
      } = this.newPasswordData;
      const data = {
        password,
        token,
      };
      this.showSecurity = false;
      this.$refs.newPassordForm.validate((validate) => {
        if (validate) {
          user.changePassword(data).then((res) => {
            if (res.data.status == 200) {
              setTimeout(() => {
                this.loginData.userName = this.newPasswordData.phone;
                this.loginData = {
                  userName: this.newPasswordData.phone,
                  password: '',
                };
                this.resetChangePwdForm();
              }, 1000);
              this.jumpTo(1);
              this.$Message.success({
                content: '修改成功！请手工输入新密码登录',
                duration: 5,
              });
            } else {
              this.$Message.error(res.data.error);
            }
          });
        }
      });
    },
    sendSMS() {
      const data = {
        phone: this.findPasswordData.phone,
        verificationCode: this.authCode,
      };
      user.sendCode(data).then((res) => {
        if (res.data.status == 200) {
          this.startTimeout();
          this.setFieldValidateState('findPhone', 'success');
          this.setFieldValidateState('findAuthCodeContainer', 'success');
        } else if (res.data.status == 70009) {
          this.refreshAuthCode();
          this.setFieldValidateState('findAuthCodeContainer', 'error', '请输入正确的验证码');
        } else {
          this.setFieldValidateState('findPhone', 'error', res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    validateSMS() {
      const data = {
        phone: this.findPasswordData.phone,
        code: this.findPasswordData.code,
      };
      if (!data.phone) {
        this.setFieldValidateState('findPhone', 'error', '请输入手机号');
        return;
      }
      this.setFieldValidateState('findPhone', 'success');

      if (!data.code) {
        this.setFieldValidateState('findCode', 'error', '请输入验证码');
        return;
      }
      this.setFieldValidateState('findCode', 'success');

      user.validateCode(data).then((res) => {
        if (res.data.status == 200) {
          this.newPasswordData.token = res.data.data;
          this.newPasswordData.phone = this.findPasswordData.phone;
          this.jumpTo(3);
          this.resetFindPwdForm();
          this.setFieldValidateState('findCode', 'success');
        } else {
          // 修改文本框状态
          this.setFieldValidateState('findCode', 'error', res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    resetFindPwdForm() {
      this.findPasswordData = {
        phone: '',
        code: '',
      };
    },
    onNewPasswordFocus() {
      this.showSecurity = true;
      this.setFieldValidateState('newPasswordDataPassword', 'success');
    },
    resetChangePwdForm() {
      this.newPasswordData = {
        password: '',
        passwordAgain: '',
        token: '',
        phone: '',
      };
    },
    /**
     * 修改表单字段验证状态
     * state: success, error
     */
    setFieldValidateState(name, state, msg) {
      const field = this.$refs[name];
      if (state === 'error') {
        field.validateMessage = msg;
      }
      field.validateState = state;
    },
    // 校验手机号，有，发送，没有修改验证
    getCode() {
      const phone = this.findPasswordData.phone;
      if (!phone) {
        this.setFieldValidateState('findPhone', 'error', '请输入手机号');
        return;
      }
      if (!this.authCode) {
        this.setFieldValidateState('findAuthCodeContainer', 'error', '请输入正确的验证码');
        return;
      }
      if (!/^\d{11}$/.test(phone)) {
        this.setFieldValidateState('findPhone', 'error', '请输入正确的手机号');
        return;
      }
      this.setFieldValidateState('findPhone', 'success');
      if (this.showAuthCode) {
        this.setFieldValidateState('findAuthCodeContainer', 'success');
      }
      this.sendSMS();
    },
    refreshAuthCode() {
      user.getAuthCodeData().then((res) => {
        this.authCodeData = res.data.image;
      })
        .catch((err) => {
          utils.handleError(err);
        });
    },
    startTimeout() {
      this.showTimeout = true;
      const timer = setInterval(() => {
        if (this.waitTime <= 0) {
          this.showTimeout = false;
          this.waitTime = 60;
          clearInterval(timer);
          return;
        }
        this.waitTime -= 1;
      }, 1000);
    },
    handlelogin() {
      if (!(this.loginData.userName && this.loginData.password)) {
        this.$Message.error('请输入用户名和密码');
        return;
      }
      if (this.showAuthCode && !this.authCode) {
        this.setFieldValidateState('authCodeContainer', 'error', '请输入正确的验证码');
        return;
      }
      if (this.showAuthCode) {
        this.setFieldValidateState('authCodeContainer', 'success');
      }
      const tempLoginData = {
        account: this.loginData.userName,
        password: this.loginData.password,
      };
      if (this.showAuthCode) {
        tempLoginData.verificationCode = this.authCode;
      }
      user.login(tempLoginData)
        .then((res) => {
          if (res.data.status === 200) {
            this.saveName(this.loginData.userName);
            this.$Message.success('登录成功');
            this.authority(true, this.$route.query.redirect);
          } else if (res.data.status === 70008 || res.data.status === 70009) {
            this.showAuthCode = true;
            this.$Message.error(res.data.error);
            this.refreshAuthCode();
          } else {
            this.showAuthCode = false;
            this.$Message.error(res.data.error);
          }
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  mounted() {
    // this.testBrowser();
  },
};
</script>
<style lang="less">
.login-container{
  background: #ffffff;
  .login-header-word{
    line-height: 20px;
    font-size: 12px;
    color: rgba(0,0,0,0.75);
    cursor: pointer;
  }
  .security-wrap{
    position: relative;
    top: -12px;
  }
  .security-item{
    display: inline-block;
    width: 30px;
    height: 8px;
    background-color: rgba(0,0,0,0.24);
    margin-right: 4px;
  }
  .sercurity-low{
    background-color: #FF4D07;
  }
  .sercurity-medium{
    background-color: #FF9500;
  }
  .sercurity-high{
    background-color: #2DBE60;
  }
  .gray-icon,.gray-word{
    color:rgba(0,0,0,0.25);
  }
  .cuurent-login-header-word{
    color: #1890FF;
  }
  .login-header-word-login{
    position: absolute;
    top: 18px;
    right: 127px;
  }
  .login-header-word-forget{
    position: absolute;
    top: 18px;
    right: 56px;
  }
  .loginHeader{
    width: 1200px;
    height: 56px;
    position: relative;
    margin: 0 auto;
    padding-top: 12px;
    img{
      width: 70px;
      height: 32px;
    }
  }

  .center{
    background: linear-gradient(to left,#0B68F3,#28C5FF );
    // height: 850px;
    height: calc(~"100vh - 188px");
    min-height: 479px;
    overflow: hidden;
        position: relative;
    .ball{
      width: 100px;
      height: 100px;
      background: #ffffff;
      border-radius: 50%;
      &:nth-child(1){
        width: 1000px;
        height:1000px;
        left: -500px;
        top:-100px;
        position: absolute;
        background: linear-gradient(to left,#2B9AFF ,#0B68F3);


      }
      &:nth-child(2){
        width: 600px;
        height:600px;
        right: 100px;
        bottom:-400px;
        position: absolute;
        background: linear-gradient(to left,#34F4F6  ,#2B9AFF);


      }
      &:nth-child(3){
        width: 800px;
        height:800px;
        right: -100px;
        top:-400px;
        position: absolute;
        background: linear-gradient(to left,#28C5FF ,#0B68F3);


      }
    }
    .centerHolder{
      max-width: 1200px;
      margin: 0 auto;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100%;
      img{
        // position: absolute;
        top:120px;
        width: calc(~'100vw - 500px ');
        // top: calc(~'100vw - 800px ');
        min-width:380px;
        max-width:600px;

      }
      .formContainer{
        min-height: 238px;
        .ivu-card-head{
          padding: 0 32px;
          p{
            height: 48px;
            line-height: 48px;
            font-size: 14px;
            color: #595959;
          }
        }
        .ivu-card-body{
          padding: 32px;
          padding-top: 24px;
        }
        .ivu-form-item{
          margin-bottom: 16px;
        }
        .login-input{
          margin-bottom: 4px;
        }

      }
    }
  }
  // width: 1300px;
  // margin: 0 auto;
  // padding: 100px;
  .formContainer{
    width: 360px;
    box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.12);
    &:hover{
      box-shadow: none;
    }
  }
  .loginfooter{
    display: flex;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;

    // flex-flow: 0;
    // flex-grow: 0;
    height: 132px;
    .intro{
      border-left: 1px solid #e9e9e9;
      padding-left:  40px;
      padding-right:  155px;
      margin-left:  40px;
      div:first-child{
        color: #595959;
        font-weight: 800;
        margin-bottom: 8px
      }
    }
    img:last-child{
      width: 70px;
      height: 70px;
    }
  }
  .no-chrome-container{
    height: 100vh;
    .no-chrome-wrap{
      position: absolute;
      width: 800px;
      top: 40%;
      left: 50%;
      transform: translate(-50%, 0px);
      text-align: center;
    }
    .chrome-grey-text{
      font-size: 22px;
      color: rgba(0,0,0,0.65);
      text-align: center;
      line-height:30px;
    }
    .chrome-black-text{
      font-size: 22px;
      color: rgba(0,0,0,0.87);
      text-align: center;
      line-height: 30px;
    }
  }
  .input-password > .ivu-input{
  -webkit-text-security:disc;
}
}
.authCode {
    width: 72px !important;
    min-width: 72px !important;
    height: 17px;
    text-align: center;
}
.refreshButton {
  text-align: center;
  margin-left: 9px;
  border-style: none;
}
.codeContain {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
}
</style>
